export default function CrownIcon({ size = 22, className = "" }) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 64 64"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            aria-hidden="true"
        >
            <path
                d="M14 39 L11.5 23 L22 31 L32 14 L42 31 L52.5 23 L50 39 Z"
                fill="currentColor"
            />
            <rect x="14" y="43" width="36" height="5" rx="2.5" fill="currentColor" />
            <circle cx="32" cy="12" r="2" fill="currentColor" />
        </svg>
    );
}
